import RedirectNotice from './RedirectNotice';

export default RedirectNotice;
